import { useEffect, useRef } from "react";

export default function PageAudio({ src, volume = 1}) {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.volume = volume;

    const tryPlay = () => {
      audio.play().catch(() => {});
    };

    tryPlay();

    document.addEventListener("click", tryPlay, { once: true });
    document.addEventListener("touchstart", tryPlay, { once: true });

    return () => {
      audio.pause();
      audio.currentTime = 0;
      document.removeEventListener("click", tryPlay);
      document.removeEventListener("touchstart", tryPlay);
    };
  }, [src, volume]);

  return (
    <audio ref={audioRef} loop preload="auto">
      <source src={src} type="audio/mpeg" />
    </audio>
  );
}